module.exports = __webpack_public_path__ + "static/img/Frame 1862.0ce43c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls3/Frame 1862.png
// module id = //gl
// module chunks = 12